import api from './api.service';

export interface Role {
  id: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
  usersCount?: number;
}

export interface CreateRoleData {
  name: string;
}

export interface UpdateRoleData {
  name: string;
}

class RoleService {
  private readonly BASE_PATH = '/roles';

  /**
   * Obtener todos los roles
   */
  async getAllRoles(): Promise<Role[]> {
    const response = await api.get<Role[]>(this.BASE_PATH);
    return response.data;
  }

  /**
   * Obtener rol por ID
   */
  async getRoleById(roleId: string): Promise<Role> {
    const response = await api.get<Role>(`${this.BASE_PATH}/${roleId}`);
    return response.data;
  }

  /**
   * Crear nuevo rol
   */
  async createRole(roleData: CreateRoleData): Promise<Role> {
    const response = await api.post<Role>(this.BASE_PATH, roleData);
    return response.data;
  }

  /**
   * Actualizar rol
   */
  async updateRole(roleId: string, roleData: UpdateRoleData): Promise<Role> {
    const response = await api.put<Role>(`${this.BASE_PATH}/${roleId}`, roleData);
    return response.data;
  }

  /**
   * Eliminar rol
   */
  async deleteRole(roleId: string): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`${this.BASE_PATH}/${roleId}`);
    return response.data;
  }
}

export default new RoleService();
